exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".expertise-included[data-v-34ab3ad0] {\n  padding: 2em 0;\n  margin-bottom: 1.5em;\n}\n.expertise-included .top-wrap[data-v-34ab3ad0] {\n  padding: 1.5em 0;\n}\n@media only screen and (min-width: 960px) and (max-width: 1300px) {\n.expertise-included .top-wrap[data-v-34ab3ad0] {\n    margin: auto;\n    max-width: 20em;\n}\n}\n", ""]);

// exports
